export const roles = {
    superAdmin: 'SUPER_ADMIN',
    admin: 'ADMIN',
    accountingChief: 'ACCOUNTING_DEPARTMENT_CHIEF',
    accountingStaff: 'ACCOUNTING_DEPARTMENT_PERSONAL',
    advisoryChief: 'ADVISORY_DEPARTMENT_CHIEF',
    advisoryStaff: 'ADVISORY_DEPARTMENT_PERSONAL',
    commercial: 'COMMERCIAL',
    membersChief: 'MEMBERS_DEPARTMENT_CHIEF',
    membersStaff: 'MEMBERS_DEPARTMENT_PERSONAL',
    queriesChief: 'QUESTIONS_DEPARTMENT_CHIEF',
    queriesStaff: 'QUESTIONS_DEPARTMENT_PERSONAL',
};